import React, { useState, useEffect, useRef } from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
// import Loader from "../../biztran_controls/Loader";


const CreateContact = (props) => {
  const classes = useStyles();
  const [Mode, setMode] = useState("");
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const [response, fetchData] = UseFetchData();
  const [Salutation, setSalutation] = useState("");
  const [ContactName, setContactName] = useState("");
  const [Designation, setDesignation] = useState("");
  const [Department, setDepartment] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Phone, setPhone] = useState("");
  const [Email, setEmail] = useState("");
  const [Address1, setAddress1] = useState("");
  const [Address2, setAddress2] = useState("");
  const [City, setCity] = useState("");
  const [CountryID, setCountryID] = useState("");
  const [StateID, setStateID] = useState("");
  const [PINCode, setPINCode] = useState("");
  const [Countrycmb, setCountrycmb] = useState([]);
  const [Statecmb, setStatecmb] = useState([]);
  const { value, onChange, ...rest } = props;
  const [cursor, setCursor] = useState(null);
  const ref = useRef(null);
  const [loading, setLoading] = useState(true);


  const validationSchema = Yup.object({
    ContactName: Yup.string().required("Required!"),
    Mobile: Yup.string().required("Required!"),
  });

  const SalutationOptions = [
    { key: "Mr", value: "Mr" },
    { key: "Ms", value: "Ms" },
    { key: "Mrs", value: "Mrs" },
    { key: "Dr", value: "Dr" },
    { key: "Prof", value: "Prof" },
  ];

  const DepartmentOptions = [
    { key: "IT", value: "IT" },
    { key: "Sales", value: "Sales" },
    { key: "System Administration ", value: "System Administration " },
  ];

  const SalutationData = () => {
    let SalutationCombo = SalutationOptions.map((data) => (
      <option key={data.key} value={data.value}>
        {data.key}
      </option>
    ));
    return SalutationCombo;
  };

  const DepartmentData = () => {
    let DepartmentCombo = DepartmentOptions.map((data) => (
      <option key={data.key} value={data.value}>
        {data.key}
      </option>
    ));
    return DepartmentCombo;
  };

  useEffect(() => {
    const input = ref.current;
    if (input) input.setSelectionRange(cursor, cursor);
  }, [ref, cursor, value]);

  const handleChange = (e) => {
    // setCursor(e.target.selectionStart);
    onChange && onChange(e);
  };

  const onSubmit = (values) => {
    setMode("Insert");
    // debugger;
    // var mob = +91;
    var UpdatedByID = sessionStorage.UID;
    var bodyFormData = new FormData();
    bodyFormData.append("ContactID", props.ContactID);
    bodyFormData.append("Salutation", values.Salutation);
    bodyFormData.append("ContactName", values.ContactName);
    bodyFormData.append("AccountID", props.AccountID);
    bodyFormData.append("Designation", Designation);
    bodyFormData.append("Department", Department);
    bodyFormData.append("Mobile", values.Mobile);
    bodyFormData.append("Phone", values.Phone);
    bodyFormData.append("Email", values.Email);
    bodyFormData.append("Address1", values.Address1);
    bodyFormData.append("Address2", values.Address2);
    bodyFormData.append("City", values.City);
    bodyFormData.append("CountryID", values.CountryID);
    bodyFormData.append("StateID", values.StateID);
    bodyFormData.append("PINCode", values.PINCode);
    bodyFormData.append("UpdatedByID", UpdatedByID);
    setLoading(true);
    fetchData("Contact/Save", bodyFormData);
  };

  useEffect(() => {
    // debugger;
    if (response.Response === true) {
      props.setOpen(false);
      props.PopulateData()
      setLoading(false);
    }
    else if (response.Response === false) {
      if (response.Message.includes("Already") === true) {
        alert(response.Message);
        setLoading(false);
      }
      else {
        alert("Failed.");
        setLoading(false);

      }
    }
    if (props.ContactID !== "") {
      setMode("Update");
    } else {
      setMode("Insert");
    }
    if (response.length > 0 && Mode === "Update") {
      // debugger;
      setLoading(false);
      setSalutation(
        response[0].Salutation === null ? "" : response[0].Salutation
      );
      setContactName(
        response[0].ContactName === null ? "" : response[0].ContactName
      );
      setDesignation(
        response[0].Designation === null ? "" : response[0].Designation
      );
      setDepartment(
        response[0].Department === null ? "" : response[0].Department
      );
      setMobile(response[0].Mobile === null ? "" : response[0].Mobile);
      setPhone(response[0].Phone === null ? "" : response[0].Phone);
      setEmail(response[0].Email === null ? "" : response[0].Email);
      setAddress1(response[0].Address1 === null ? "" : response[0].Address1);
      setAddress2(response[0].Address2 === null ? "" : response[0].Address2);
      setCountryID(response[0].CountryID === null ? "" : response[0].CountryID);
      setStateID(response[0].StateID === null ? "" : response[0].StateID);
      setCity(response[0].City === null ? "" : response[0].City);
      setPINCode(response[0].Salutation === null ? "" : response[0].PINCode);
    }
  }, [response]);

  const CountryData = (options) => {
    // debugger;
    if (options !== undefined) {
      let Country = options.map((data) => (
        <option key={data.Country} value={data.CountryID}>
          {data.Country}
        </option>
      ));
      setCountrycmb(Country);
    }
  };

  const StatecmbData = (CID) => {
    // debugger;
    var id = "";
    if (CID !== "") {
      id = CID;
    } else if (CountryID !== "") {
      id = CountryID;
    } else {
      id = "";
    }
    let options = ComboDataResponse["State"];
    if (options !== undefined) {
      if (id !== "") {
        let State = options
          .filter((option) => option.CountryID === id)
          .map((data) => (
            <option key={data.StateName} value={data.StateID}>
              {data.StateName}
            </option>
          ));
        setStatecmb(State);
      } else {
        let State = options.map((data) => (
          <option key={data.StateName} value={data.StateID}>
            {data.StateName}
          </option>
        ));
        setStatecmb(State);
      }
    }
  };

  useEffect(() => {
    // debugger;
    if (ComboDataResponse !== undefined) {
      setLoading(false);
      if (ComboDataResponse["Country"] !== undefined) {
        CountryData(ComboDataResponse["Country"]);
        StatecmbData("");
        if (props.ContactID !== "") {
          StatecmbData("");
          setMode("Update");
          GetContactData();
        } else {
          setMode("Insert");
        }
      }
    }
  }, [ComboDataResponse]);

  const GetContactData = () => {
    // debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("ContactID", props.ContactID);
    setLoading(false);
    fetchData("Contact/GetByID", bodyFormData);
  };

  useEffect(() => {
    GetComboData();
    console.log(props.AccountName)
  }, []);

  const GetComboData = () => {
    // debugger;
    setLoading(false);
    fetchComboData("Contact/ComboDataContact");
  };

  const onSelectChange = (e) => {
    // debugger;
    let targetvalue = e.target.value;
    let targetname = e.target.name;
    if (targetvalue !== "") {
      // debugger;

      if (targetname === "CountryID") {
        setCountryID(targetvalue);
        StatecmbData(targetvalue);
      } else if (targetname === "StateID") {
        setStateID(targetvalue);
      }
    } else {
      if (targetname === "CountryID") {
        setCountryID("");
        StatecmbData("");
      } else if (targetname === "CountryID") {
        setStateID(targetvalue);
      }
    }
  };

  let SalutationCombo = SalutationData();
  let DepartmentCombo = DepartmentData();

  return (
    <div>
      {/* {
        loading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 10,
          }}>
            <Loader />
          </div>
        )
      } */}
      <Formik
        initialValues={{
          Salutation: Salutation,
          ContactName: ContactName,
          Designation: Designation,
          Department: Department,
          Mobile: Mobile,
          Phone: Phone,
          Email: Email,
          Address1: Address1,
          Address2: Address2,
          CountryID: CountryID,
          StateID: StateID,
          City: City,
          PINCode: PINCode,
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <Typography className={classes.headertext} noWrap>
                Contact Information
              </Typography>
              <Grid spacing={2} container direction="row">
                {/* <Grid item xs={2}>
                  <label
                    htmlFor={"Salutation"}
                    style={{ display: "block", width: "100%" }}
                  >
                    {"Salutation"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    control="select"
                    // label='Account Type'
                    name="Salutation"
                    options={SalutationCombo}
                    onChange={(e) => setSalutation(e.target.value)}
                  />
                </Grid> */}
                <Grid item xs={2}>
                  <label
                    htmlFor={"Salutation"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Salutation"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="input"
                    type="text"
                    name="Salutation"
                    ref={ref}
                    value={Salutation}
                    onChange={(e) => {
                      setSalutation(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"ContactName"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Contact Name"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="input"
                    type="text"
                    name="ContactName"
                    ref={ref}
                    value={ContactName}
                    onChange={(e) => {
                      setContactName(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>

                <Grid item xs={2}>
                  <label
                    htmlFor={"AccountID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Account"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    disabled
                    name="AccountID"
                    value={props.AccountName}
                  />
                </Grid>

                <Grid item xs={2}>
                  <label
                    htmlFor={"Designation"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Designation"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    name="Designation"
                    // autoFocus="autofocus"
                    ref={ref}
                    value={Designation}
                    onChange={(e) => {
                      setDesignation(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"Department"}
                    style={{ display: "block", width: "100%" }}
                  >
                    {"Department"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    name="Department"
                    // autoFocus="autofocus"
                    ref={ref}
                    value={Department}
                    onChange={(e) => {
                      setDepartment(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                {/* <Grid item xs={4}>
                  <BiztranControlsFormik
                    control="select"
                    // label='Account Type'
                    name="Department"
                    options={DepartmentCombo}
                    onChange={(e) => setDepartment(e.target.value)}
                  />
                </Grid> */}
                {/* <Grid item xs={2}>
                  <label
                    htmlFor={"Department"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Department"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    name="Department"
                    onChange={(e) => setDepartment(e.target.value)}
                  />
                </Grid> */}
                <Grid item xs={2}>
                  <label
                    htmlFor={"Mobile"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Mobile"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    control="input"
                    type="number"
                    name="Mobile"
                    // autoFocus="autofocus"
                    ref={ref}
                    value={Mobile}
                    onChange={(e) => {
                      setMobile(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"Phone"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Phone"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    control="input"
                    type="number"
                    name="Phone"
                    // autoFocus="autofocus"
                    ref={ref}
                    value={Phone}
                    onChange={(e) => {
                      setPhone(e.target.value)
                      handleChange()
                    }
                    }
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"Email"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Email"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    control="input"
                    type="email"
                    name="Email"
                    // autoFocus="autofocus"
                    ref={ref}
                    value={Email}
                    onChange={(e) => {
                      setEmail(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
              </Grid>
              <Grid spacing={2} container direction="row">
                <Grid item xs={12}></Grid>
                <Grid item xs={12}></Grid>

                <Grid item xs={12}>
                  <Typography className={classes.headertext} noWrap>
                    Office Address Information
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <BiztranControlsFormik
                    control="textarea"
                    type="text"
                    label="Address1"
                    name="Address1"
                    // autoFocus="autofocus"
                    ref={ref}
                    value={Address1}
                    onChange={(e) => {
                      setAddress1(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="select"
                    label="Country"
                    name="CountryID"
                    options={Countrycmb}
                    onChange={onSelectChange}
                  />
                </Grid>

                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="select"
                    label="State"
                    name="StateID"
                    options={Statecmb}
                    onChange={onSelectChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                      }}
                    >
                      <BiztranControls.Button
                        text="SAVE"
                        type="submit"
                        startIcon={<SaveIcon />}
                      />
                      <BiztranControls.Button
                        text="CLOSE"
                        startIcon={<CloseIcon />}
                        onClick={() => {
                          props.setOpen(false);
                        }}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    paddingLeft: "30px",
    fontSize: "1.5rem",
    marginTop: "-16px",
    marginBottom: "10px",
    marginLeft: "-24px",
    marginRight: "-24px",
    //   borderRadius: "1rem",
  },
}));

export default CreateContact;
